import { render, staticRenderFns } from "./UnitRegistSettings.vue?vue&type=template&id=6256cec5&scoped=true"
import script from "./UnitRegistSettings.vue?vue&type=script&lang=js"
export * from "./UnitRegistSettings.vue?vue&type=script&lang=js"
import style0 from "./UnitRegistSettings.vue?vue&type=style&index=0&id=6256cec5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6256cec5",
  null
  
)

export default component.exports